import React, { ReactElement } from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { Backdrop, CircularProgress, Stack } from '@mui/material';
import { createPortal } from 'react-dom';

interface LoadingPlaceholderProps {
    sx?: SxProps<Theme>;
    children?: ReactElement;
    open?: boolean;
    dataTest?: string;
    variant?: 'primary' | 'secondary'; //primary - black backdrop and white text , secondary -  white backdrop and black text
    relativeToParent?: boolean;
}

export default function LoadingPlaceholder({
    sx,
    children,
    open = true,
    dataTest,
    variant = 'primary',
    relativeToParent = false,
}: LoadingPlaceholderProps) {
    return (
        <Backdrop
            data-test={dataTest}
            sx={{ ...(relativeToParent ? { position: 'absolute' } : {}), ...(sx ?? {}) }}
            open={open}
            className={`loading-placeholder loading-placeholder--view-${variant}`}
        >
            <Stack spacing={2} direction={'column'} alignItems={'center'} className={'loading-placeholder__container'}>
                <CircularProgress color="inherit" className={'loading-placeholder__icon'} />
                {children}
            </Stack>
        </Backdrop>
    );
}

export function BodyLoadingPlaceholder(props: LoadingPlaceholderProps) {
    return createPortal(
        <LoadingPlaceholder relativeToParent {...props} sx={{ ...props.sx, zIndex: 99999 }}>
            {props.children}
        </LoadingPlaceholder>,
        document.body,
    );
}
